import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import Col from 'ui-library/bs/Col';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {Optional} from 'util/Types';

interface PrimerRowIntervalListProps {
  inputs: Array<{
    value: string;
    onChange: (e: {target: {value: string}}) => void;
    placeholder: string | number | null;
  }>;
  selection: {
    start: number;
    end: Optional<number>;
  };
}

class PrimerRowIntervalList extends React.Component<PrimerRowIntervalListProps> {
  disableAddFromSelection = (): boolean => this.props.selection.end == null;

  addFromSelection = (): void => {
    const interval = `${this.props.selection.start}-${this.props.selection.end}`;
    const current = this.props.inputs[0].value;
    const newValue = current ? `${current.trim()},${interval}` : interval;
    this.props.inputs[0].onChange({target: {value: newValue}});
  };

  override render(): JSX.Element {
    let key;
    assert(this.props.inputs.length === 1, 'PrimerRowIntervalList should have exactly one input');
    return (
      <div>
        {(() => {
          const result = [];
          for (key = 0; key < this.props.inputs.length; key++) {
            const input = this.props.inputs[key];
            result.push(
              <Col md={6} key={key}>
                <input
                  {
                    // TODO: refactor _.extend to be type-explicit
                    ..._.extend({type: 'text'}, input) // eslint-disable-line no-restricted-syntax
                  }
                />
              </Col>
            );
          }
          return result;
        })()}
        <Col md={4}>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            onClick={this.addFromSelection}
            disabled={this.disableAddFromSelection()}
            key={key}
            text="Add selection"
          />
        </Col>
      </div>
    );
  }
}

export default PrimerRowIntervalList;
